
import React from 'react';

// import NonFSIndex from '../../components/NonFSIndex';

export default function SkillIndex() {
  // return (
  //   <NonFSIndex
  //     data_type="skill"
  //   />
  // );
  return <></>
}
